/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
.a-link {
  border-bottom-width: 0;
}
.a-link .a-link__text {
  border-bottom-width: 1px;
  border-bottom-style: inherit;
}

.a-link--jump {
  font-weight: 500;
}
@media only all and (max-width: 37.5em) {
  .a-link--jump {
    display: flex;
    align-items: center;
    gap: 0.3125rem;
    box-sizing: border-box;
    padding-top: 0.625em;
    padding-bottom: 0.625em;
    border-top-width: 1px;
    border-bottom-width: 1px;
    width: 100%;
  }
  .a-link--jump .cf-icon-svg--right {
    margin-left: auto;
  }
  .a-link--jump .a-link__text {
    border-bottom-width: 0;
    flex-shrink: 10;
  }
}

@media only all and (max-width: 37.5em) {
  li:has(.a-link--jump) + li:has(.a-link--jump) .a-link--jump {
    position: relative;
    border-top: none;
  }
  li:has(.a-link--jump) + li:has(.a-link--jump) .a-link--jump:hover::before {
    position: absolute;
    top: -1px;
    content: "";
    display: block;
    height: 1px;
    width: 100%;
    border-top: 1px solid currentcolor;
  }
}